import { Label } from "../model/Label.js";
import { Marker } from "./Marker.js";
import { Table } from "./Table.js";

export class Popup {

    constructor(public readonly marker: Marker) {

        var data = marker.data;

        this.marker.marker.bindPopup(
            (layer) => {

                layer.getPopup().options.maxWidth = Math.min(500, window.innerWidth - 85);

                var table = new Table();
                if (data.size) {
                    table.label("immo.size", data.size);
                }
                if (data.type_of_use && data.type_of_use.length > 0) {
                    table.label("immo.type_of_use", data.type_of_use.join(", ").toUpperCase());
                }
                if (data.availability) {
                    table.label("immo.availability", data.availability);
                }

                return `
                <div class="e5-popup__content" data-immoid="${data.id}">
                    ${data.title ? `<h2 class="e5-popup__title">${e5.Text.escapeHtml(data.title)}</h2>` : ""}
                    ${data.address ? `<div class="e5-popup__address">${e5.Text.escapeHtml(data.address)}</div>` : ""}
                    ${table.toString()}
                    <a class="e5-base__button" href="${data.permalink}">
                        <span class="e5-base__button-label">${Label.html("map.goto_report")}</span>
                        <span class="e5-base__button-icon fas fa-arrow-circle-right"></span>
                    </a>
                </div>`;
            },
            {
                closeButton: false,
                offset: [0, -50],
                autoPanPaddingTopLeft: [55, 40],
                autoPanPaddingBottomRight: [10, 10],
                className: "e5-popup"
            }).openPopup();
    }

    public open():void{
        this.marker.marker.openPopup();
    }
}